document.addEventListener("DOMContentLoaded", function (event) {
  var el = document.getElementById('popup');
  var main = document.getElementsByTagName('main')[0];
  var sticker = document.getElementById('sticker');
  var btn = document.getElementById('popup-close-button');
  var body = document.getElementsByTagName('body')[0];

  function lightsOff() {
    if (el) {
      el.classList.remove("d-none");
      main.classList.add("bg-black");
      main.classList.add("darken-ctrl");
      sticker.classList.add("darken-ctrl");
    }
  }

  function lightsOn() {
    if (el) {
      el.classList.add("d-none");
      main.classList.remove("bg-black");
      main.classList.remove("darken-ctrl");
      sticker.classList.remove("darken-ctrl");
    }
  }

  if (btn) {
    btn.addEventListener('click', function handleClick() {
      lightsOn();
    });
  }

  if (body.classList.contains("home")) {
    setTimeout(() => {
      lightsOff();
    }, 400);
  }

});
